import { render, staticRenderFns } from "./folderConfig.vue?vue&type=template&id=02d5d4dc&scoped=true&"
import script from "./folderConfig.vue?vue&type=script&lang=js&"
export * from "./folderConfig.vue?vue&type=script&lang=js&"
import style0 from "./folderConfig.vue?vue&type=style&index=0&id=02d5d4dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d5d4dc",
  null
  
)

export default component.exports